export const contactInformation = {
  contact: {
    title: 'contact@bsdigital.com',
    url: 'mailto:contact@bsdigital.com'
  },
  sales: {
    title: 'sales@bsdigital.com',
    url: 'mailto:sales@bsdigital.com'
  },
  dsb: {
    title: 'dsb@boerse-stuttgart.de',
    url: 'mailto:dsb@boerse-stuttgart.de'
  },
  custodyWebsite: {
    title: 'custody.bsdigital.com',
    url: 'https://custody.bsdigital.com'
  },
  boerseStuttgartWebsite: {
    title: 'www.boerse-stuttgart.de',
    url: 'https://www.boerse-stuttgart.de'
  },
  accountManagement: {
    title: 'account-management@bsdigital.com',
    url: 'mailto:account-management@bsdigital.com'
  }
};

export default contactInformation;
